<script>
	import ExpectedVote from './ExpectedVote.svelte';
	import { formatPercent } from '../utils/format.js';
  import Photos from './Photos.svelte';
  import { intcomma } from 'journalize';
  import parties from '../utils/parties';
  import lastNameDict from '../utils/nameDictionary';




  /** @type {import('../types.d').ReadableRace} */
  export let race;

  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  /** @type {string} */
  export let name;
  // /** @type {string} */
  // export let link;
  /** @type {string} */
  export let slug;



  $: raceName = name;
  // $: raceLink = link;
	$: totalVotes = $race.total_votes
	$: numOfwinners = $race.number_of_winners
	$: office = $race.office

  const facelist = [
    // 'CA-D8620-2024-11-05'//'los-angeles-district-attorney'
  ]
  const face = facelist.includes($race.id)

  // const face = false;

  $: alwaysShowCandidates = (slug !== "hp-senate-class-i") ? 2 : 3

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
</script>
{#each $race.candidates as c, idx}
  {#if c.is_incumbent}
  <p class="winner-incumbent text-sans-serif mt-0 text-left"><span>* Incumbent</span></p>
  {/if}
{/each}
<table class="contest__candidates">
  <thead>
    <tr>
      <th  scope="col" colspan="1" class="contest__candidate-header">
      </th>
      <th scope="col" colspan={face? 2:1}  class="contest__candidate-header text-uppercase">
        {#if office == "I" || office == "Cities" || name == 'measure' }Support{:else}Candidate{/if}
      </th>
      <th scope="col" class="contest__candidate-header text-left text-uppercase">
       Votes
      </th>
      <th scope="col" class="contest__candidate-header text-uppercase total-votes">
        Total
      </th>
    </tr>
  </thead>
  <tbody>
    {#each $race.candidates as c, idx}
      {#if (raceName !== 'prop') &&  (idx < alwaysShowCandidates) }
        <tr class="candidate contest__candidate-row">
          <td class="candidate__cell candidate__cell-bar">
            <div
            class="bar bar-{c.party}"
          >
            {#if c.is_winner == true}
              <div class="candidate__cell-winner" aria-label="checkmark, winner"> ✓ </div>
            {/if}
          </div>
          </td>
          {#if face}
          <td class="candidate__cell">
            <div class="candidate__cell-headshot {slugify(`${c.given_name} ${c.family_name}`)}">
              <Photos 
                name = {c.given_name + ' ' + c.family_name}
                src = {crosswalk[c.ap_id].png}
                avif = {crosswalk[c.ap_id].avif}
                webp = {crosswalk[c.ap_id].webp}
                party= None
              />              
            </div>
            </td>
            {/if} 
          <th
            scope="row"
            class="candidate__cell candidate__cell-name"
          >
          {#if c.given_name}{c.given_name}{/if} {lastNameDict(c.family_name)}&nbsp;{#if c.is_incumbent}<span
                class="candidate__cell-incumbent"
                title="Currently holds this office">*</span
              >
          {/if}
          {#if !['I', 'M', '0', 'D', 'Cities'].includes(office) && (name !== 'measure')}
          <span class="candidate__cell-name-party">({parties[c.party] ? parties[c.party].abbr : (c.party).toUpperCase()})</span>
          {/if}
          {#if c.is_runoff}
                <span class="candidate__cell-runoff candidate__">Runoff</span>
          {/if} 
          </th>
          <td
            class="candidate__cell candidate__cell-pct text-left">
            {formatPercent(c.votes, totalVotes, 1)}
                <span class="candidate__pct-symbol">%</span>
          </td>
          <td
            class="candidate__cell candidate__cell-pct text-right total-votes">
            {intcomma(c.votes)}
          </td>
        </tr>
      {/if}
    {/each}
  </tbody>
  {#if office !== 'Cities'}
    {#if $race.eevp != null}
    <tfoot>
      <tr>
        <td colspan="4" class="contest__precincts text-left" data-component-field="hp-embed-eevp">
            {$race.eevp}% of expected vote in
        </td>
      </tr>
    </tfoot>
    {/if}
  {/if}
</table>